import { PAYOUT_STATUS } from '../../../constants';

export const calculateItemsFullTotalAmount = (payouts) => {
    return payouts.map((row) => {
        const summary = { amount: 0, fee: 0, refunded: 0, owed: 0, paid: 0 };

        const isPayoutAlreadyProcessed = [
            PAYOUT_STATUS.PAID,
            PAYOUT_STATUS.PROCESSING,
            PAYOUT_STATUS.PENDING,
            PAYOUT_STATUS.FAILED
        ].includes(row.status);

        row.items?.forEach((item) => {
            const amount = item.amount || 0;
            const fee = item.fee || 0;
            const refunded = item.refunded || 0;
            const paid = item.paid || 0;

            const baseNet = amount - fee - refunded;

            const itemNet = isPayoutAlreadyProcessed ? baseNet : baseNet - paid;
            // we include fee to offset balance, so to avoid negative balance do not include it in summary owed
            const summaryNet = isPayoutAlreadyProcessed ? baseNet : amount - refunded - paid;

            item.owed = itemNet;

            // exclude payout item with status offset refund from owed amount
            if (item.type !== 3) {
                summary.owed += summaryNet;
                summary.amount += amount;
                summary.fee += fee;
                summary.refunded += refunded;
                summary.paid += paid;
            }
        });

        return {
            ...row,
            amount: summary.amount,
            fee: summary.fee,
            refunded: summary.refunded,
            paid: summary.paid,
            owed: summary.owed
        };
    });
};
